var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.company)?_c('div',{staticClass:"read"},[_c('image-loader',{attrs:{"src":_vm.company.logo.thumb,"icon":"grid-dark"}}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.user.name)}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }